import { FC } from 'react';

import { Box } from '@versumstudios/ui';

interface ITextComponent {
  value: string | number;
}

export const TextComponent: FC<ITextComponent> = ({ value }) => {
  return <Box css={{ fontSize: 14, color: '$secondaryFill' }}>{value}</Box>;
};
